import { memo } from "react"

const GroupNode = memo(({ id, data }) => {
  return (
    <div className="group-node">
      {data.label && (
        <div className="group-label">{data.label}</div>
      )}
    </div>
  )
})

GroupNode.displayName = "GroupNode"

export default GroupNode
